'use client';

import { ReactNode, useEffect } from 'react';
import { AuthProvider } from '@/context/AuthContext';
import { SiteConfigProvider } from '@/context/SiteConfigContext';
import { NotificationsProvider } from '@/context/NotificationsContext';
import { api } from '@/utils/api';

export default function AppProviders({ children }: { children: ReactNode }) {

  useEffect(() => {
    // Lógica de parceiros rodando diretamente na Home (sem travar a página)
    const checkPartnerSlug = async () => {
      if (typeof window === 'undefined') {
        return;
      }
      const params = new URLSearchParams(window.location.search);
      const ref = params.get('ref');
      if (ref) {
        try {
          // Persiste para uso posterior no checkout/assinatura
          localStorage.setItem('referrerNick', ref);

          await api.get(`parceiros/click/${ref}`, {
            cacheTtlSeconds: 0
          });
          // Remove o parâmetro da URL silenciosamente após registrar
          const newUrl = window.location.pathname;
          window.history.replaceState({}, '', newUrl);
        } catch (error) {
          console.error('Erro ao registrar parceiro:', error);
        }
      }
    };

    checkPartnerSlug();
  }, []);

  return (
    <AuthProvider>
      <SiteConfigProvider>
        <NotificationsProvider>
          {children}
        </NotificationsProvider>
      </SiteConfigProvider>
    </AuthProvider>
  );
}
